export class PartyUser
{
  public CON_USERID: number;
  public ACC_CODE: string;
  public ACC_NAME: string;
  public MOB_NUMBER: string;
  public PASSWORD: string;
  public CREATED_BY: number;
  public CREATED_DATE: string;
  public UPDATED_BY: number;
  public UPDATED_DATE: string;
  public IS_FIRSTLOGIN: number;
  public USER_TYPE: string;
  public EMAIL: string;
  public RequestSource: string;
}
